// src/pages/register/register.js
import React, { useEffect, useState } from "react";
import { Form, Input, Button, message, Modal, Card, Checkbox } from "antd";
import { RESTExecutor, withDomains } from "../../lib/domain";
import CryptoJS from "crypto-js";
import GenerateTurnstileToken from "../../components/turnstile";
import { LockOutlined, CheckOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

let email = "";

const key = "981239812312312323";

function loadFromSessionStorage() {
  try {
    const serializedState = sessionStorage.getItem("regId");
    if (serializedState === null) {
      return undefined;
    }
    const decrypted = CryptoJS.AES.decrypt(serializedState, key).toString(
      CryptoJS.enc.Utf8
    );
    return JSON.parse(decrypted);
  } catch {
    return undefined;
  }
}

function saveToSessionStorage(state) {
  try {
    const serializedState = JSON.stringify(state);
    const encrypted = CryptoJS.AES.encrypt(serializedState, key);
    sessionStorage.setItem("regId", encrypted);
  } catch (e) {
    console.log(e);
  }
}

const customStyles = `
  :root { --basic-input-height: 40px !important; }
  .register-form .ant-form-item { margin-bottom: 0 !important; }
  .register-form .ant-form-item-label { padding: 0 !important; margin-bottom: 4px !important; }
  .register-form .ant-form-item-label > label {
    color: #636972 !important; font-size: 12px !important; font-family: 'Inter' !important;
    font-weight: 500 !important; height: auto !important; line-height: normal !important;
  }
  .register-form .ant-form-item-label > label::after { display: none !important; }
  .register-form .ant-input {
    background: #FAFAFA !important; border: none !important; border-radius: 6px !important;
    height: 40px !important; min-height: 40px !important; max-height: 40px !important;
    font-size: 12px !important; font-family: 'Inter' !important; font-weight: 400 !important;
    color: #343C46 !important; padding: 8px 16px !important; outline: 1px #E0E5EB solid !important;
    outline-offset: -1px !important; box-shadow: none !important; line-height: 1.2 !important;
  }
  .register-form .ant-input:focus, .register-form .ant-input:hover {
    outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; border: none !important;
  }
  .register-form .ant-input::placeholder {
    color: #BFC3C9 !important; font-size: 12px !important; font-family: 'Inter' !important; font-weight: 400 !important;
  }
  .register-form .ant-input-affix-wrapper {
    background: #FAFAFA !important; border: none !important; border-radius: 6px !important;
    height: 40px !important; min-height: 40px !important; max-height: 40px !important;
    padding: 8px 16px !important; outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; line-height: 1.2 !important;
  }
  .register-form .ant-input-affix-wrapper:focus, .register-form .ant-input-affix-wrapper:hover,
  .register-form .ant-input-affix-wrapper-focused {
    outline: 1px #E0E5EB solid !important; outline-offset: -1px !important;
    box-shadow: none !important; border: none !important;
  }
  .register-form .ant-input-affix-wrapper .ant-input {
    background: transparent !important; border: none !important; outline: none !important;
    box-shadow: none !important; padding: 0 !important; height: auto !important; line-height: 1.2 !important;
  }
  .register-form .ant-input-affix-wrapper .ant-input:focus {
    box-shadow: none !important; border: none !important; outline: none !important;
  }
  .register-form .ant-form-item-explain-error {
    color: #E82E49 !important; font-size: 12px !important; font-family: 'Inter' !important; margin-top: 4px !important;
  }
  .register-form .invalid-input { outline: 1px #E82E49 solid !important; outline-offset: -1px !important; }
  .register-form .ant-input-suffix { margin-left: 8px !important; }
  .password-indicator {
    width: 12px; height: 12px; border-radius: 2.24px; display: flex; align-items: center; justify-content: center;
    font-size: 8px; color: white; font-weight: bold;
  }
  .password-indicator.valid { background: #1DB954; }
  .password-indicator.invalid { background: #E82E49; border-radius: 50%; width: 8px; height: 8px; }
  .custom-checkbox {
    width: 20px !important; height: 20px !important; border-radius: 4px !important; border: 1px solid #143E9F !important;
    background: #143E9F !important; display: flex !important; align-items: center !important; justify-content: center !important;
    cursor: pointer !important;
  }
  .custom-checkbox.unchecked { background: transparent !important; border: 1px solid #E0E5EB !important; }
  .login-text-link {
    color: var(--Main-blue, #143E9F) !important; font-size: 12px !important; font-family: 'Inter' !important;
    font-weight: 700 !important; line-height: 18px !important; cursor: pointer !important; text-decoration: none !important;
  }
  .login-text-link:hover { text-decoration: underline !important; color: var(--Main-blue, #143E9F) !important; }
  @media (max-width: 768px) {
    .email-phone-row { flex-direction: column !important; gap: 20px !important; }
    .register-container { padding-left: 20px !important; padding-right: 20px !important; }
  }
`;

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) setMatches(media.matches);
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);
  return matches;
};

const RegisterPage = ({ domains, ...props }) => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [initialEmail, setInitialEmail] = useState();
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isNameValid, setIsNameValid] = useState(true);
  const [cloudflareToken, setCloudflareToken] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
  const [isPolicyModalVisible, setIsPolicyModalVisible] = useState(false);

  const showTermsModal = (value) => setIsTermsModalVisible(value);
  const showPolicyModal = (value) => setIsPolicyModalVisible(value);

  const queryStringToObject = (url) =>
    [...new URLSearchParams(url.split("?")[1])].reduce(
      (a, [k, v]) => ((a[k] = v), a),
      {}
    );

  const getEmailFromQuery = () => {
    try {
      const routeQueryString = props?.location?.search;
      if (routeQueryString) {
        const routeParams = queryStringToObject(routeQueryString);
        if (routeParams?.email) return routeParams.email;
      }

      const hash = window.location.hash || "";
      const hashQueryIndex = hash.indexOf("?");
      if (hashQueryIndex !== -1) {
        const hashQueryString = hash.slice(hashQueryIndex);
        const hashParams = queryStringToObject(hashQueryString);
        return hashParams?.email;
      }
    } catch (err) {
      console.error("Failed to read email query param", err);
    }
    return undefined;
  };

  const validateAndSanitizeText = (text, maxLength = 100) => {
    if (!text) return text;
    return text.replace(/[<>"\\/{}[\];%&$]/g, '').substring(0, maxLength).trim();
  };

  const validateFullName = (name) => {
    if (!name || name.trim().length === 0) return false;
    const validPattern = /^[a-zA-Z\s\-'.]+$/;
    return validPattern.test(name.trim()) && name.trim().length >= 2 && name.trim().length <= 100;
  };

  const validateEmail = (email) => {
    if (!email) return false;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email) && !email.includes('+') && !email.includes('=');
  };

  const validatePhoneNumber = (phone) => {
    if (!phone) return false;
    const phonePattern = /^\d{10}$/;
    return phonePattern.test(phone);
  };

  const validatePassword = (password) => {
    if (!password) return false;
    const passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,20}$/;
    return passwordPattern.test(password);
  };

  const handleNameChange = (e) => {
    const value = validateAndSanitizeText(e.target.value, 100);
    setIsNameValid(validateFullName(value));
  };

  const handleEmailChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[+=]/g, '');
    value = validateAndSanitizeText(value, 100);
    setIsEmailValid(validateEmail(value));
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setIsPhoneValid(validatePhoneNumber(value));
  };

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  const getPasswordIndicator = (password) => {
    if (!password) return null;
    const isValid = validatePassword(password);
    return (
      <div className={`password-indicator ${isValid ? 'valid' : 'invalid'}`}>
        {isValid ? <CheckOutlined style={{ fontSize: '8px' }} /> : ''}
      </div>
    );
  };

  const getConfirmPasswordIndicator = (password, confirmPassword) => {
    if (!confirmPassword) return null;
    const isMatch = password && confirmPassword && password === confirmPassword && validatePassword(password);
    return (
      <div className={`password-indicator ${isMatch ? 'valid' : 'invalid'}`}>
        {isMatch ? <CheckOutlined style={{ fontSize: '8px' }} /> : ''}
      </div>
    );
  };

  useEffect(() => {
    const queryEmail = getEmailFromQuery();
    if (queryEmail) {
      const sanitizedEmail = validateAndSanitizeText(queryEmail, 100).replace(/[+=]/g, "");
      setInitialEmail(sanitizedEmail);
    }
  }, []);

  let register_user = RESTExecutor.post()
    .config({
      label: "register",
    })
    .callbacks(
      (success) => {
        if (success && (success.error === false || success.success === true)) {
        saveToSessionStorage({ id: success.result.id, email: email });
          history.push({ pathname: `/verify-code` });
        } else {
          console.error("Registration failed or unexpected response:", success);
          message.error("Registration failed. Please try again.");
        }
      },
      (error) => {
        console.error("Registration error:", error);
        if (error.validation_errors) {
          Object.keys(error.validation_errors).forEach(field => {
            const fieldError = error.validation_errors[field];
            message.error(`${field}: ${fieldError}`);
          });
        } else if (error.error_message === "email already taken") {
          message.error("The email address entered is already in use.");
        } else if (error.error_message) {
          message.error(error.error_message);
        } else {
          message.error("Registration failed. Please try again.");
        }
      }
    )
    .connect(domains.register);

  const onFinish = (formData) => {
    if (!termsAccepted) {
      message.error("Please accept the terms and conditions.");
      return;
    }
    if (!validateFullName(formData.name)) {
      message.error("Please enter a valid full name (2-100 characters, letters only).");
      return;
    }
    if (!validateEmail(formData.email)) {
      message.error("Please enter a valid email address.");
      return;
    }
    if (!validatePhoneNumber(formData.phone_number)) {
      message.error("Please enter a valid phone number (10 digits only).");
      return;
    }
    if (!validatePassword(formData.new_password)) {
      message.error("Password must contain at least one capital letter, one special character, one number, and be 8 to 20 characters long.");
      return;
    }
    if (formData.new_password !== formData.confirm_password) {
      message.error("Passwords do not match.");
      return;
    }
    email = formData?.email;

    const userData = {
      name: formData.name,
      passowrd: formData.new_password, 
      confirm_password: formData.confirm_password,
      phone_number: formData.phone_number
    };
    const encryptedUserData = CryptoJS.AES.encrypt(JSON.stringify(userData), key);
    sessionStorage.setItem("userData", encryptedUserData);

    const apiData = {
      name: formData.name,
      email: formData.email,
      passowrd: formData.new_password, 
      confirm_password: formData.confirm_password,
      phone_number: formData.phone_number,
      cloudflare_token: cloudflareToken
    };

    register_user.execute(apiData);
  };

  let register_resp = register_user.response();
  let { validation_errors = {} } = register_user.response();

  return (
    <>
      <style>{customStyles}</style>
      <div
        className="register-container"
        style={{
          width: '100vw',
          height: '100vh',
          paddingLeft: 100,
          paddingRight: 100,
          background: '#EEF2F7',
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <div
          style={{
            width: 700,
            paddingLeft: 32,
            paddingRight: 32,
            paddingTop: 40,
            paddingBottom: 40,
            background: '#FAFAFA',
            boxShadow: '0px 28px 62px rgba(37, 78, 207, 0.03)',
            borderRadius: 16,
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 18,
            display: 'flex'
          }}
        >
          <div style={{
            alignSelf: 'stretch',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 24,
            display: 'flex'
          }}>
            <div style={{
              flex: '1 1 0',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
              display: 'flex'
            }}>
              <div style={{
                alignSelf: 'stretch',
                color: '#343C46',
                fontSize: 24,
                fontFamily: 'Inter',
                fontWeight: '700',
                wordWrap: 'break-word'
              }}>
                Create New Account
              </div>
              <div style={{
                color: '#636972',
                fontSize: 12,
                fontFamily: 'Inter',
                fontWeight: '400',
                wordWrap: 'break-word'
              }}>
                Let's get started with your 15 days free trial
              </div>
            </div>
            <img
              src="images/tigg_logo.png"
              style={{
                width: 'auto',
                height: '44.75px'
              }}
              alt="Tigg Logo"
            />
          </div>

          <div style={{
            alignSelf: 'stretch',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 16,
            display: 'flex',
          }}>
            <Form
              name="register"
              className="register-form"
              key={`${initialEmail}`}
              initialValues={{
                remember: true,
                email: initialEmail,
              }}
              onFinish={onFinish}
              layout="vertical"
              style={{ width: '100%' }}
            >
              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 24,
                display: 'flex'
              }}>
                <div style={{
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 24,
                  display: 'flex'
                }}>
                  <div style={{
                    alignSelf: 'stretch',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 20,
                    display: 'flex'
                  }}>
                    <div style={{
                      alignSelf: 'stretch',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 4,
                      display: 'flex'
                    }}>
                      <div style={{
                        color: '#636972',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '500',
                        wordWrap: 'break-word'
                      }}>
                        Full Name*
                      </div>
                      <Form.Item
                        name="name"
                        style={{ alignSelf: 'stretch', width: '100%' }}
                        validateStatus={!isNameValid ? "error" : ""}
                        help={
                          !isNameValid
                            ? "Please enter a valid full name (2-100 characters, letters only)."
                            : (validation_errors?.name ?? [null])[0]
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input your Full Name",
                          },
                          {
                            min: 2,
                            message: "Full name must be at least 2 characters long.",
                          },
                          {
                            max: 100,
                            message: "Full name cannot exceed 100 characters.",
                          },
                          {
                            pattern: /^[a-zA-Z\s\-'.]+$/,
                            message: "Full name can only contain letters, spaces, hyphens, and apostrophes.",
                          },
                        ]}
                      >
                        <Input 
                          placeholder="John Doe" 
                          onChange={handleNameChange}
                          className={!isNameValid ? "invalid-input" : ""}
                          maxLength={100}
                        />
                      </Form.Item>
                    </div>

                    <div 
                      className="email-phone-row"
                      style={{
                        alignSelf: 'stretch',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 12,
                        display: 'flex'
                      }}
                    >
                      <div style={{
                        flex: '1 1 0',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 4,
                        display: 'flex',
                        width: '100%'
                      }}>
                        <div style={{
                          color: '#636972',
                          fontSize: 12,
                          fontFamily: 'Inter',
                          fontWeight: '500',
                          wordWrap: 'break-word'
                        }}>
                          Email*
                        </div>
                        <Form.Item
                          name="email"
                          style={{ alignSelf: 'stretch', width: '100%' }}
                          validateStatus={!isEmailValid ? "error" : ""}
                          help={
                            !isEmailValid
                              ? "Please enter a valid email address."
                              : (validation_errors?.email ?? [null])[0]
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please input your Email!",
                            },
                            {
                              type: 'email',
                              message: 'Please enter a valid email address.',
                            },
                            {
                              validator: (_, value) => {
                                                                if (!value) return Promise.resolve();
                                if (value.includes('+') || value.includes('=')) {
                                  return Promise.reject(new Error('Email cannot contain + or = characters.'));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            prefix={<img src="images/user.svg" alt="email-icon" />}
                            placeholder="john.doe@example.com"
                            className={!isEmailValid ? "invalid-input" : ""}
                            onChange={handleEmailChange}
                            maxLength={100}
                          />
                        </Form.Item>
                      </div>

                      <div style={{
                        flex: '1 1 0',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 4,
                        display: 'flex',
                        width: '100%'
                      }}>
                        <div style={{
                          color: '#636972',
                          fontSize: 12,
                          fontFamily: 'Inter',
                          fontWeight: '500',
                          wordWrap: 'break-word'
                        }}>
                          Phone Number*
                        </div>
                        <Form.Item
                          name="phone_number"
                          style={{ alignSelf: 'stretch', width: '100%' }}
                          validateStatus={!isPhoneValid ? "error" : ""}
                          help={
                            !isPhoneValid
                              ? "Please enter a valid phone number (10 digits only)."
                              : (validation_errors?.phone_number ?? [null])[0]
                          }
                          rules={[
                            {
                              required: true,
                              message: "Please input your Phone number!",
                            },
                            {
                              pattern: /^\d{10}$/,
                              message: "Please enter a valid phone number (10 digits only).",
                            },
                          ]}
                        >
                          <Input 
                            placeholder="9841234567" 
                            onChange={handlePhoneChange}
                            className={!isPhoneValid ? "invalid-input" : ""}
                            maxLength={10}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div style={{
                      alignSelf: 'stretch',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 4,
                      display: 'flex',
                      paddingBottom: 8,
                    }}>
                      <div style={{
                        color: '#636972',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '500',
                        wordWrap: 'break-word'
                      }}>
                        Password*
                      </div>

                      <Form.Item
                        name="new_password"
                        style={{ alignSelf: 'stretch', width: '100%' }}
                        rules={[
                          {
                            required: true,
                            message: "Please input your Password!",
                          },
                          {
                            pattern:
                              /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()])[A-Za-z\d!@#$%^&*()]{8,20}$/,
                            message:
                              "Must contain at least one capital letter, one special character, one number, and be 8 to 20 characters long.",
                          },
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          suffix={getPasswordIndicator(password)}
                          placeholder="****************"
                          onChange={handlePasswordChange}
                        />
                      </Form.Item>

                      <Form.Item
                        name="confirm_password"
                        style={{ alignSelf: 'stretch', width: '100%' }}
                        dependencies={['new_password']}
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your Password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('new_password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('The two passwords do not match!'));
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined />}
                          suffix={getConfirmPasswordIndicator(password, confirmPassword)}
                          placeholder="****************"
                          onChange={handleConfirmPasswordChange}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>

              <GenerateTurnstileToken
                setToken={(token) => setCloudflareToken(token)}
              />

              <div style={{
                alignSelf: 'stretch',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 24,
                display: 'flex'
              }}>
                <div style={{
                  alignSelf: 'stretch',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 8,
                  display: 'flex'
                }}>
                  <div 
                    className={`custom-checkbox ${termsAccepted ? '' : 'unchecked'}`}
                    onClick={() => setTermsAccepted(!termsAccepted)}
                  >
                    {termsAccepted && (
                      <CheckOutlined style={{ fontSize: '10px', color: 'white' }} />
                    )}
                  </div>
                  <div style={{ flex: '1 1 0' }}>
                    <span style={{
                      color: '#636972',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '400',
                      lineHeight: '18px',
                      wordWrap: 'break-word'
                    }}>
                      I agree to Tigg's{' '}
                    </span>
                    <span 
                      style={{
                        color: 'var(--Main-blue, #143E9F)',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        lineHeight: '18px',
                        wordWrap: 'break-word',
                        cursor: 'pointer'
                      }}
                      onClick={() => showTermsModal(true)}
                    >
                      Term of Service
                    </span>
                    <span style={{
                      color: '#636972',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '400',
                      lineHeight: '18px',
                      wordWrap: 'break-word'
                    }}>
                      {' '}and{' '}
                    </span>
                    <span 
                      style={{
                        color: 'var(--Main-blue, #143E9F)',
                        fontSize: 12,
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        lineHeight: '18px',
                        wordWrap: 'break-word',
                        cursor: 'pointer'
                      }}
                      onClick={() => showPolicyModal(true)}
                    >
                      Privacy Policy
                    </span>
                  </div>
                </div>
                <div style={{
                  alignSelf: 'stretch',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 8,
                  display: 'flex'
                }}>
                  <Button
                    loading={register_resp?.fetching ?? false}
                    htmlType="submit"
                    disabled={!cloudflareToken || !termsAccepted}
                    style={{
                      alignSelf: 'stretch',
                      paddingLeft: 16,
                      paddingRight: 16,
                      paddingTop: 12,
                      paddingBottom: 12,
                      background: (cloudflareToken && termsAccepted) ? 'var(--Main-blue, #143E9F)' : '#CBD0D6',
                      boxShadow: '0px 8px 24px -8px rgba(20, 62, 159, 0.16)',
                      overflow: 'hidden',
                      borderRadius: 6,
                      border: 'none',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 8,
                      display: 'flex',
                      color: 'white',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '600',
                      lineHeight: '18px',
                      cursor: (cloudflareToken && termsAccepted) ? 'pointer' : 'not-allowed',
                      height: 'auto'
                    }}
                  >
                    Create Account
                  </Button>

                  <div 
                    style={{
                      alignSelf: 'stretch',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      padding: '12px 16px',
                      gap: 8,
                    }}
                  >
                    <span style={{
                      color: '#343C46',
                      fontSize: 12,
                      fontFamily: 'Inter',
                      fontWeight: '500',
                      lineHeight: '18px',
                      wordWrap: 'break-word'
                    }}>
                      Already a user?{' '}
                    </span>
                    <span 
                      className="login-text-link"
                      onClick={() => history.push("/")}
                    >
                      Log in
                    </span>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modal
        className="terms-modal"
        id="terms-modal"
        maskClosable={false}
        title="Terms of Service"
        visible={isTermsModalVisible}
        onCancel={() => {
          showTermsModal(false);
        }}
        bodyStyle={{
          height: 500,
          backgroundColor: "#EEF2F7",
          margin: "20px",
          overflow: "auto",
        }}
        footer={[<></>]}
      >
        <p>
          B.I.C. Technology Private Limited and/or its affiliates ("BIC") are
          willing to provide access to the Service to you as the company or
          entity using it (referred to as "Customer") if you agree to all the
          terms in this Agreement. By accepting this Agreement on behalf of an
          entity or organization, you confirm you have the authority to bind
          that entity or organization to these terms.
        </p>
        <p>
          Both Customer and BIC are referred to as a “Party” individually and
          “Parties” together.
        </p>

        <p>
          Both Customer and BIC are referred to as a "Party" individually and
          "Parties" together.
        </p>

        <p>
          Please read this Agreement carefully. By agreeing electronically or
          using the Service, you accept the terms. If you do not agree, do not
          proceed with the acceptance or use of the Service.
        </p>

        <h1>Description of Service</h1>
        <p>
          BIC provides a cloud-based accounting platform designed to streamline
          financial management for businesses. Our Services include, but are not
          limited to, Accounting and Bookkeeping, Invoicing and Billing,
          Inventory Management, Bank Reconciliation, Document Management, CRM,
          Expenses Management, Financial Reporting Etc.
        </p>

        <p>
          Please note that access to certain features may be limited based on
          your subscription plan. You will only be able to use the features
          included in the subscription you have purchased. The scope of our
          Services may evolve, and any significant changes will be communicated
          in accordance with our Terms of Service.
        </p>

        <h1>Registration Data and Privacy</h1>
        <p>
          In order to access some of the services, you will be required to use
          an account and password that can be obtained by completing our online
          registration form, which requests certain information and data ("Sign
          Up"), and maintaining and updating your Registration Data as required.
          By registering, you agree that all information provided in the
          Registration Data is true and accurate and that you will maintain and
          update this information as required in order to keep it current,
          complete, and accurate.
        </p>

        <h1>Organization Accounts and Administrators</h1>
        <p>
          When you sign up for an account for your organization, the initiating
          user automatically becomes the administrator. The administrator will
          have the right to configure the Services based on your requirements
          and manage end users in your organization account. If your
          organization account is created and configured on your behalf by a
          third party, it is likely that such a third party has assumed an
          administrator role for your organization. Make sure that you enter
          into a suitable agreement with such a third party specifying such
          party's roles and restrictions as an administrator of your
          organization account.
        </p>

        <p>You are responsible for:</p>

        <ul>
          <li>
            ensuring confidentiality of your organization account password,
          </li>
          <li>
            appointing competent individuals as administrators for managing your
            organization account, and
          </li>
          <li>
            ensuring that all activities that occur in connection with your
            organization account comply with this Agreement.
          </li>
        </ul>

        <p>
          You understand that BIC is not responsible for account administration
          and internal management of the Services for you. You are responsible
          for taking the necessary steps for ensuring that your organization
          does not lose control of the administrator accounts.
        </p>

        <p>
          Changes to the administrator role can only be made by BIC. To request
          a change, the current administrator must email support@tiggapp.com
          from the email address registered at the time of account creation. If
          this email address is unavailable, we may request additional legal
          documents to verify the organization's ownership before making the
          change.
        </p>

        <h1>Computerized Billing Compliance</h1>
        <p>
          If you subscribe to our Computerised Billing feature, both parties
          agree to comply with all requirements set by the Inland Revenue
          Department of Nepal, including adhering to the terms, conditions, and
          any updates issued by the department. Failure by either party to meet
          these requirements may result in fines and penalties. Each party
          agrees to indemnify the other for any losses or damages incurred due
          to the other party's non-compliance. For more details, please refer to
          the Electronic Billing Procedure, 2074 (विद्युतीय बीजक सम्बन्धी
          कार्यविधि, २०७४).
        </p>

        <h1>Subscription and Renewals</h1>
        <ul>
          <li>
            The customer shall pay a subscription fee in advance without any
            deduction or set-off (except for Tax withholding if applicable)
            INVOICE will be generated only after payment of the subscription fee
            in advance.
          </li>
          <li>
            Without prejudice to Customer's rights set out elsewhere in this
            Agreement, all subscription fees are non-refundable and payable in
            advance.
          </li>
          <li>
            From time to time, we may change the price of any Service or charge
            for use of Services that are currently available free of charge. Any
            increase in charges will not apply until the expiry of your
            then-current billing cycle. You will not be charged for using any
            Service unless you have opted for a paid subscription plan.
          </li>
          <li>
            In order to provide continuous service, we automatically renew all
            paid subscriptions for the Services on the date such subscriptions
            expire. Such renewals are for the same duration as the original
            subscription term (for example, a 1-year subscription will renew on
            a yearly basis). By entering into this Agreement, you acknowledge
            that your account will be subject to the above-described automatic
            renewals. In all cases, if you do not wish your account to renew
            automatically, please contact BIC'S support before the expiration of
            such a subscription.
          </li>
          <li>
            Except as otherwise stated in this section, you may cancel your paid
            subscription at any time during the term of such subscription or any
            renewal period by completely cancelling the account.
          </li>
          <li>
            In such a case, your subscription will terminate, and you will not
            receive any refund for any unused days of such subscription term.
          </li>
        </ul>

        <h1>Trademark</h1>
        <p>
          BIC, Tigg, the BIC logo, the Tigg logo, and the names and logos of
          individual Services are trademarks of B.I.C. Technology. You agree not
          to display or use these trademarks in any manner without prior
          permission from BIC.
        </p>
        <p>
          Our obligation to protect your Confidential Information will continue
          even after the termination of your use of our service. We will
          implement appropriate technical and organizational measures to
          safeguard your information against unauthorized access, loss, or
          theft.
        </p>
        <p>
          You also agree to keep any information we provide to you, which is
          marked as confidential or should reasonably be understood to be
          confidential, strictly confidential and to use it only for the
          purposes for which it was disclosed.
        </p>

        <h1>Confidential Information</h1>
        <p>
          We will not disclose your Confidential Information to any third party
          without your prior written consent, except as required by law or
          necessary for the provision of the Services. In such cases, we will
          make reasonable efforts to notify you in advance, unless prohibited by
          law.
        </p>

        <p>
          Our obligation to protect your Confidential Information will continue
          even after the termination of your use of our service. We will
          implement appropriate technical and organizational measures to
          safeguard your information against unauthorized access, loss, or
          theft.
        </p>

        <p>
          You also agree to keep any information we provide to you, which is
          marked as confidential or should reasonably be understood to be
          confidential, strictly confidential and to use it only for the
          purposes for which it was disclosed.
        </p>

        <h1>Data Security, Backup and Recovery</h1>
        <p>
          BIC will implement and maintain appropriate technical and
          organizational measures to protect Customer data from unauthorized
          access, cyber-attacks, and data breaches within its systems and
          infrastructure.
        </p>

        <p>
          BIC will maintain regular backups of Customer data to protect against
          data loss due to system failures, cyber-attacks, or other incidents.
          These backups will be used solely for restoration purposes in the
          event of a verified data loss.
        </p>

        <p>
          If BIC becomes aware of a confirmed or suspected data breach or
          unauthorized access affecting Customer data, BIC will notify the
          Customer without undue delay, including details of the incident,
          remedial actions taken, and expected resolution timelines.
        </p>

        <p>
          BIC's liability for any data loss, breach, or failure to restore data
          shall be subject to the Limitation of Liability clause set forth in
          this Agreement.
        </p>

        <h1>Data Ownership and Disclosure</h1>
        <p>
          You own all your business's private data, content, and information
          that you enter and use in connection with the Services. We do not
          claim any rights, proprietary or otherwise, over any data or
          information you may use or disclose in connection with Tigg. However,
          there may be circumstances where we are required to disclose data,
          such as:
        </p>

        <ul>
          <li>
            To comply with any legal, governmental or regulatory requirement;
          </li>
          <li>To comply with a court order.</li>
        </ul>

        <p>
          If we are required to disclose your data or information, we will use
          our best efforts to provide you with reasonable notice in the
          circumstances and if appropriate the right to challenge any such
          request.
        </p>
        <ol>
          <li>
            To comply with any legal, governmental or regulatory requirement;
          </li>
          <li>To comply with a court order.</li>
        </ol>
        <p>
          If we are required to disclose your data or information, we will use
          our best efforts to provide you with reasonable notice in the
          circumstances and if appropriate the right to challenge any such
          request.
        </p>

        <p>
          Tigg uses AI technologies to power features like document scanning and
          transaction suggestions. Some of these features rely on trusted
          third-party AI providers, and limited data may be securely shared with
          them solely to deliver the specific functionality. We do not use your
          data to train any AI models, and we only work with AI providers who
          explicitly confirm that they do not use user data for training their
          models. All data handling follows strict privacy and security
          standards.
        </p>

        <h1>Data Access and Retention Upon Non-Renewal or Termination</h1>
        <p>
          In the event of non-renewal or termination of services, B.I.C
          Technology will not be liable for any data loss incurred by the
          customer. Upon expiration of the subscription, B.I.C Technology will
          provide a grace period of at least one (1) month for customers to
          access and retrieve their data. After this period, B.I.C Technology is
          no longer responsible for maintaining or storing the customer's data,
          which may be permanently deleted.
        </p>

        <p>
          For terminated accounts, data will be deleted within 60 days of
          notifying the client. If the client cannot be reached, data will be
          automatically deleted after 120 days. Clients subject to IRD billing
          compliance will have their data deleted only after obtaining approval
          from relevant tax authorities. While customers can request data
          deletion on demand, this option is not available for IRD-compliant
          clients due to regulatory requirements. Additionally, B.I.C Technology
          offers a read-only subscription plan for clients who wish to continue
          accessing their data post-termination.
        </p>

        <h1>Force Majeure</h1>
        <p>
          Neither party should be held liable for a delay or failure in
          performance of the agreement for services caused by reason of any
          occurrence of unforeseen event beyond its reasonable control,
          including but not limited to, acts of God, natural disasters, power
          failures, server failures, third party service provider failures or
          service interruptions, embargo, labour disputes, lockouts and strikes,
          riots, war, floods, insurrections, legislative changes, and
          governmental actions. The party so affected by the unforeseen event
          shall be so excused on a day-to-day basis for the period of time equal
          to that of the underlying cause of delay.
        </p>

        <h1>Restriction on Use</h1>
        <p>
          You must use Tigg responsibly and in a way that does not harm,
          disrupt, or negatively impact other users. Use of automated tools,
          scripts, or any methods that interfere with the normal operation of
          Tigg or affect other users is strictly prohibited.
        </p>
        <p>
          We reserve the right to suspend or terminate your access without
          notice if we reasonably believe your actions compromise the trust,
          security, or functionality of the platform or its users. You also
          agree to be fully responsible for, and to cover, any damages, losses,
          or costs arising from your inappropriate use of Tigg.
        </p>

        <h1>Terms and Termination</h1>
        <p>
          This Agreement is effective as of the Effective Date and continues
          until the expiration of all subscription terms, unless terminated
          earlier as specified herein. You may choose to stop using the Software
          and terminate this Agreement at any time for any reason by providing
          written notice to BIC. However, you will not be entitled to a refund
          of any prepaid fees. If you have not yet paid all applicable fees for
          the current subscription term or related services period, any
          outstanding fees will become immediately due and payable.
        </p>

        <h1>Limitation of Liability</h1>
        <p>
          To the maximum extent permitted by law, Bic Technology shall not be
          liable for any indirect, incidental, special, consequential, or
          punitive damages, or any loss of profits or revenues, whether incurred
          directly or indirectly, or any loss of data, use, goodwill, or other
          intangible losses, resulting from your use of the Service.
        </p>

        <h1>Indemnification</h1>
        <p>
          Each party agrees to defend, indemnify, and hold the other party and
          its affiliates harmless from and against all liabilities, claims, and
          expenses, including attorney fees, arising out of or related to any
          misuse, negligence, or breach of obligations under this agreement by
          the indemnifying party.
        </p>

        <h1>End of Terms of Service</h1>

        <p>
          If you have any questions or concerns regarding this Agreement, please
          contact us at{" "}
          <a href="mailto:hello@tiggapp.com">hello@tiggapp.com.</a>
        </p>
      </Modal>

      <Modal
        className="policy-modal"
        id="policy-modal"
        maskClosable={false}
        title="Privacy Policy"
        visible={isPolicyModalVisible}
        onCancel={() => {
          showPolicyModal(false);
        }}
        bodyStyle={{
          height: 500,
          backgroundColor: "#EEF2F7",
          margin: "20px",
          overflow: "auto",
        }}
        footer={[<></>]}
      >
        <h1>Introduction:</h1>

        <p>
          This Privacy Policy covers the information we collect about you when
          you use our products or services, or otherwise interact with us.
        </p>

        <p>
          Our products and services are offered by{" "}
          <strong>B.I.C. Technology Private Limited</strong>
          <strong> </strong> (<strong>BIC</strong>” or “<strong>we</strong>”), a
          Nepali Company (Reg No.240710/077/078).
        </p>

        <p>This privacy policy applies to:</p>

        <ul>
          <li>tiggapp.com or tigg.app and its subdomains (the “Site”);</li>
          <li>our mobile apps that incorporate this privacy policy; and</li>
          <li>
            products and services branded with the “TIGG” or “BIC” name
            (“Services”).
          </li>
        </ul>

        <p>
          We treat your personal information with the same respect we want our
          own to be treated with—and when you deal with finances like we do,
          there’s a lot of personal information involved. Here’s a list of
          exactly what we collect.
        </p>

        <h3>What Information We Collect About You</h3>
        <p>
          We collect information about you when you provide it to us, when you
          use our Services, and when other sources provide it to us, as further
          described below.
        </p>
        <ol>
          <li>
            <strong>Account and Profile Information:</strong> When you sign up
            or update your profile on our platform, we gather details such as
            your name, email address, and any preferences you set. This helps us
            manage your account and tailor the services to your needs.
          </li>
          <li>
            <strong>Content You Provide Through Our Products:</strong> As you
            use our products, we collect any information you enter. We also
            track how you interact with our services to understand which
            features you use and how you use them.
          </li>
          <li>
            <strong>Content You Provide Through Our Websites:</strong>{" "}
            Information you submit through our websites, including forms or
            comments, is collected. This also includes data from our social
            media pages that we operate.
          </li>
          <li>
            <strong>Information from Support Channels:</strong> When you contact
            our customer support for assistance, we collect details about the
            issue you’re facing and any relevant information you provide. This
            helps us address your concerns effectively.
          </li>
          <li>
            <strong>Payment Information:</strong> For transactions involving our
            paid services, we collect payment details like bank information and
            billing addresses to process payments securely.
          </li>
          <li>
            <strong>Device and Connection Information:</strong> We gather
            information about the devices you use to access our services,
            including details like your IP address, browser type, and operating
            system. This helps us ensure compatibility and troubleshoot any
            issues.
          </li>
          <li>
            <strong>Cookies and Tracking Technologies:</strong> We use cookies
            and similar technologies to remember your preferences and track your
            interactions with our services. This allows us to enhance your user
            experience and provide personalized content.
          </li>
          <li>
            <strong>Information from Other Sources:</strong> We may receive
            additional information from third parties, such as social media
            platforms or public databases. This helps us update our records and
            offer you more relevant services and advertisements.
          </li>
          <li>
            <strong>BIC’s Partners:</strong> We collaborate with partners who
            assist with consulting, training, and marketing. We may receive
            information from them related to your interactions with our products
            or services.
          </li>
          <li>
            <strong>Other Partners:</strong> We also collect information from
            partners involved in advertising and market research. This data
            helps us understand your engagement with our services and
            advertisements.
          </li>
        </ol>

        <h3>How We Use Information We Collect</h3>
        <p>
          How we use the information we collect depends in part on which
          Services you use, how you use them, and any preferences you have
          communicated to us. Below are the specific purposes for which we use
          the information we collect about you.
        </p>
        <ol>
          <li>
            <strong>
              To Provide the Services and Personalize Your Experience:
            </strong>{" "}
            We use information about you to provide the Services to you,
            including to process transactions with you, authenticate you when
            you log in, provide customer support, and operate, maintain, and
            improve the Services.
          </li>
          <li>
            <strong>For Research and Development:</strong> We are always looking
            for ways to make our Services smarter, faster, secure, integrated,
            and useful. We use information and collective learnings (including
            feedback) about how people use our Services to troubleshoot, to
            identify trends, usage, activity patterns, and areas for integration
            and to improve our Services and to develop new products, features
            and technologies that benefit our users and the public. We also test
            and analyze certain new features with some users before rolling the
            feature out to all users.
          </li>
          <li>
            <strong>To Communicate with You About the Services:</strong> We use
            your contact information to send transactional communications via
            email and within the Services, including confirming your purchases,
            reminding you of subscription expirations, responding to your
            comments, questions and requests, providing customer support, and
            sending you technical notices, updates, security alerts, and
            administrative messages. We send you email notifications when you or
            others interact with you on the Services.
          </li>
          <li>
            <strong>
              To Market, Promote, and Drive Engagement with the Services:
            </strong>{" "}
            We use your contact information and information about how you use
            the Services to send promotional communications that may be of
            specific interest to you, including by email and by displaying BIC’s
            ads on other companies' websites and applications.
          </li>
          <li>
            <strong>Customer Support:</strong> We use your information to
            resolve technical issues you encounter, to respond to your requests
            for assistance, to analyze crash information, and to repair and
            improve the Services. Where you give us express permission to do so,
            we share information with a third-party expert for the purpose of
            responding to support-related requests.
          </li>
          <li>
            <strong>For Safety and Security:</strong> We use information about
            you and your Service use to verify accounts and activity, to detect,
            prevent, and respond to potential or actual security incidents and
            to monitor and protect against other malicious, deceptive,
            fraudulent, or illegal activity.
          </li>
          <li>
            <strong>
              To Protect Our Legitimate Business Interests and Legal Rights:
            </strong>{" "}
            Where required by law or where we believe it is necessary to protect
            our legal rights, interests, and the interests of others, we use
            information about you in connection with legal claims, compliance,
            regulatory, and audit functions.
          </li>
        </ol>

        <h3>How We Share Information We Collect</h3>
        <p>
          We share information we collect about you in the ways discussed below.
          We are not in the business of selling information about you to
          advertisers or other third parties.
        </p>

        <h5>
          <strong>Sharing with Other Service Users</strong>
        </h5>
        <p>
          When you use the Services, we share certain information about you with
          other Service users.
        </p>
        <ul>
          <li>
            <strong>For Collaboration:</strong> You can create content, which
            may contain information about you, and grant permission to others to
            see, share, edit, copy, and download that content based on settings
            you or your administrator (if applicable) select.
          </li>
          <li>
            <strong>Managed Accounts and Administrators:</strong> If you’re
            using our service as a general user in an organization, your
            information—such as your name, profile picture, and contact
            details—might be visible to the organization’s administrator and
            other users within the same organization. If you’re an administrator
            for an organization, we may share your contact information with
            current users to help manage service-related requests.
          </li>
        </ul>

        <h5>
          <strong>Sharing with third parties</strong>
        </h5>
        <p>
          We share information with third parties that help us operate, provide,
          improve, integrate, customize, support and market our Services.
        </p>

        <ul>
          <li>
            <strong>Service Providers:</strong> We work with third-party service
            providers to provide website and application development, hosting,
            maintenance, backup, storage, virtual infrastructure, payment
            processing, analysis and other services for us, which may require
            them to access or use information about you. If a service provider
            needs to access information about you to perform services on our
            behalf, they do so under close instruction from us, including
            appropriate security and confidentiality procedures designed to
            protect your information.
          </li>
          <li>
            <strong>Partners: </strong> We work with third parties who provide
            consulting, sales, support, and technical services to deliver and
            implement customer solutions around the Services. We may share your
            information with these third parties in connection with their
            services, such as to assist with billing and collections, to provide
            localized support, and to provide customizations. We may also share
            information with these third parties where you have agreed to that
            sharing.
          </li>
          <li>
            <strong>With your consent: </strong> We share information about you
            with third parties when you give us consent to do so. For example,
            we often display personal testimonials of satisfied customers on our
            public websites. With your consent, we may post your name alongside
            the testimonial.
          </li>
        </ul>

        <h3>How we store and secure information we collect</h3>
        <h5>Information storage and security</h5>
        <p>
          We use industry-standard technical and organizational measures to
          secure the information we store. While we implement safeguards
          designed to protect your information, no security system is
          impenetrable and due to the inherent nature of the Internet, we cannot
          guarantee that information, during transmission through the Internet
          or while stored on our systems or otherwise in our care, is absolutely
          safe from intrusion by others.
        </p>

        <h5>How long we keep information</h5>
        <p>
          How long we keep information we collect about you depends on the type
          of information, as described in further detail below. After such time,
          we will either delete or de-identify your information or, if this is
          not possible (for example, because the information has been stored in
          backup archives), then we will securely store your information and
          isolate it from any further use until deletion is possible.
        </p>

        <h3>Changes to our Privacy Policy</h3>
        <p>
          We may change this privacy policy from time to time. We will post any
          privacy policy changes on this page and, if the changes are
          significant, we will provide a more prominent notice by sending you an
          email notification. We encourage you to review our privacy policy
          whenever you use the Services to stay informed about our information
          practices and the ways you can help protect your privacy.
        </p>

        <p>
          If you disagree with any changes to this privacy policy, you will need
          to stop using the Services and deactivate your account(s), as outlined
          above.
        </p>

        <p>
          Your information is controlled by B.I.C. Technology Private Limited.
          If you have questions or concerns about how your information is
          handled, please direct your inquiry to B.I.C. Technology Private
          Limited, which we have appointed to be responsible for facilitating
          such inquiries.
        </p>

        <p>B.I.C. Technology Private Limited</p>
        <p>Thashikhel-14, Lalitpur</p>
        <p>
          E-Mail:
          <a href="mailto:hello@tiggapp.com?subject=Inquiries">
            hello@tiggapp.com
          </a>
        </p>
      </Modal>
    </>
  );
};

export default withDomains(RegisterPage, "register");

